import cl from 'classnames'
import Image from 'next/image'

interface Props {
  image: string
  imageAlt: string
  title: string
  children: React.ReactNode
  className?: string
}

export const Card = ({
  image,
  imageAlt,
  title,
  children,
  className
}: Props) => {
  return (
    <div
      className={cl(
        'border-2 rounded-3xl flex flex-col items-center gap-y-5 pb-20 pt-10 px-7',
        className
      )}
    >
      <div>
        <Image
          src={image}
          height={120}
          width={120}
          alt={imageAlt}
          loading="lazy"
        />
      </div>
      <div className="font-chivo">
        <h3 className="font-bold text-2xl my-4 ">{title}</h3>
        {children}
      </div>
    </div>
  )
}
